import React from "react";
import clsx from "clsx";

import IcnCheck from "@assets/icons/check-fat.svg";
import { IconComponent } from "@app/core";
import { HtmlRenderComponent } from "@app/core/html-render";

import styles from "./usps-2025.module.scss";

export type Usps2025Props = {
  usps?: string[];
  className?: string;
  variant?: "onDark" | "onLight";
};

const Usps2025 = ({ usps, className, variant = "onDark" }: Usps2025Props): JSX.Element => {
  return (
    <div className={clsx(styles.root, styles[variant], className)}>
      {usps?.map((usp, index) => (
        <div key={index} className={styles.usp}>
          <div className={styles.icon}>
            <IconComponent icon={IcnCheck} size="12px" />
          </div>
          {usp && (
            <span>
              <HtmlRenderComponent html={usp} />
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export { Usps2025 };
